export default __webpack_public_path__ + "static/shop-0fd883d2b6778c2f52d49e8abd6b028d.png";